// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"403facec","239":"48aba0c8","455":"3e76878a"}[chunkId] + ".chunk.js";
};